import { createResource } from "~/lib/resourceFactory";
import { getWorkflowConfig, getWorkflowSteps } from "./workflow.api";

type WorkflowSteps = Awaited<ReturnType<typeof getWorkflowSteps>>;
type WorkflowConfig = Awaited<ReturnType<typeof getWorkflowConfig>>;

export type WorkflowStepsParams = {
  businessId: string;
  entityType: string;
  entityId: string;
};
export type WorkflowConfigParams = { businessId: string; entityType: string };

export const WorkflowStepsResource = createResource<
  WorkflowSteps,
  WorkflowStepsParams
>({
  key: (p) =>
    ["workflow-steps", p.businessId, p.entityType, p.entityId] as const,
  fetcher: (p) =>
    getWorkflowSteps({
      data: {
        businessId: p.businessId,
        entityType: p.entityType,
        entityId: p.entityId,
      },
    }),
});

export const WorkflowConfigResource = createResource<
  WorkflowConfig,
  WorkflowConfigParams
>({
  key: (p) => ["workflow-config", p.businessId, p.entityType] as const,
  fetcher: (p) =>
    getWorkflowConfig({
      data: { businessId: p.businessId, entityType: p.entityType },
    }),
});
